import { FC } from 'react'

import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'

import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import Table from './_Table'

interface Props {
  schema: EmployeeCustomTablesSchemaFragment
  resource?: Resource
  values?: Value[]
  attachableId: number
  attachableType: string
  currency: string
  canManage: boolean
  canAddValues: boolean
}

const CustomTableComponent: FC<Props> = ({
  schema,
  values,
  attachableId,
  currency,
  canManage,
  canAddValues,
}) => {
  return (
    <>
      <PanesHeader title={schema.label} />
      <Table
        attachableId={attachableId}
        schema={schema}
        values={values}
        canManage={canManage}
        canAddValues={canAddValues}
        currency={currency}
      />
    </>
  )
}

export default observer(CustomTableComponent)
